import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getLogisticRoutes(options = {}) {
	return _apiRequestWrap(
		ModulesMap.LOGISTIC_ROUTES,
		ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].GET_LOGISTIC_ROUTES,
		options
	)
}

function _getLogisticRoutePreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.LOGISTIC_ROUTES,
		ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].GET_LOGISTIC_ROUTE_PREVIEW,
		options
	)
}

function _getLogisticRoutePopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.LOGISTIC_ROUTES,
		ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].GET_LOGISTIC_ROUTE_POPUP,
		options
	)
}

function _getLogisticRoute(options = {}) {
	return _apiRequestWrap(
		ModulesMap.LOGISTIC_ROUTES,
		ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].GET_LOGISTIC_ROUTE,
		options
	)
}

function _createLogisticRoute(options = {}) {
	return _apiRequestWrap(
		ModulesMap.LOGISTIC_ROUTES,
		ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].CREATE_LOGISTIC_ROUTE,
		options
	)
}

function _putLogisticRoute(options = {}) {
	return _apiRequestWrap(
		ModulesMap.LOGISTIC_ROUTES,
		ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].PUT_LOGISTIC_ROUTE,
		options
	)
}

function _patchLogisticRoute(options = {}) {
	return _apiRequestWrap(
		ModulesMap.LOGISTIC_ROUTES,
		ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].PATCH_LOGISTIC_ROUTE,
		options
	)
}

function _deleteLogisticRoute(options = {}) {
	return _apiRequestWrap(
		ModulesMap.LOGISTIC_ROUTES,
		ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].DELETE_LOGISTIC_ROUTE,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].GET_LOGISTIC_ROUTES]: _getLogisticRoutes,

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].GET_LOGISTIC_ROUTE_PREVIEW]: _getLogisticRoutePreview,

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].GET_LOGISTIC_ROUTE_POPUP]: _getLogisticRoutePopup,

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].GET_LOGISTIC_ROUTE]: _getLogisticRoute,

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].CREATE_LOGISTIC_ROUTE]: _createLogisticRoute,

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].PUT_LOGISTIC_ROUTE]: _putLogisticRoute,

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].PATCH_LOGISTIC_ROUTE]: _patchLogisticRoute,

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].DELETE_LOGISTIC_ROUTE]: _deleteLogisticRoute,
}
